import type { SVGProps } from 'react';
const SvgCallReceived = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#call_received_svg__a)">
      <path
        fill="currentColor"
        d="M20 5.41 18.59 4 7 15.59V9H5v10h10v-2H8.41L20 5.41Z"
      />
    </g>
    <defs>
      <clipPath id="call_received_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCallReceived;
